import { createEntityAdapter } from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice";

const releaseAdapter = createEntityAdapter({
  selectId: (release) => release.id,
});

const releaseInitialState = releaseAdapter.getInitialState();

export const releaseSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getReleases: builder.query({
      query: () => `/releases`,
      transformResponse: (responseData) => {
        const loadedData = responseData;

        return releaseAdapter.setAll(releaseInitialState, loadedData);
      },
      providesTags: (result, error, arg) => {
        if (error) {
          return [{ type: "Releases", id: "ERROR" }];
        }
        return [
          { type: "Releases", id: "LIST" },
          ...(result?.ids || []).map((id) => ({
            type: "Releases",
            id,
          })),
        ];
      },
    }),
    getRelease: builder.query({
      query: (id) => `/releases/${id}`,
    }),
  }),
});
export const { useGetReleasesQuery, useGetReleaseQuery } = releaseSlice;
